import React, { useState, useEffect } from 'react';
import './BranchSelectModal.css';
import { API_V1, fetchApiWithoutBranch } from '../config/api';
import locationImage from '../assets/Recursos Graficos/location.png';

export const SELECTED_BRANCH_STORAGE_KEY = 'chefmargaro_selected_branch';

export function getStoredBranch() {
  try {
    const raw = localStorage.getItem(SELECTED_BRANCH_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

const BranchSelectModal = ({ onBranchSelected }) => {
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedBranch, setSelectedBranch] = useState('');
  const [confirmError, setConfirmError] = useState('');

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        setError(null);
        // Usar fetchApiWithoutBranch para obtener TODAS las sucursales sin filtrar por X-Branch-Id
        const res = await fetchApiWithoutBranch(
          `${API_V1}/branches?search=&per_page=20`
        );
        if (!res.ok) throw new Error('Error al cargar sucursales');
        const data = await res.json();
        const list = data.data ?? data;
        setBranches(Array.isArray(list) ? list : []);
      } catch (err) {
        setError(err.message || 'Error al cargar sucursales');
        setBranches([]);
      } finally {
        setLoading(false);
      }
    };
    fetchBranches();
  }, []);

  const handleConfirm = () => {
    setConfirmError('');
    if (!selectedBranch) {
      setConfirmError('Selecciona una sede para continuar.');
      return;
    }
    const branchId = selectedBranch;
    const branch = branches.find(
      (b) => String(b.id ?? b.branch_id) === String(branchId)
    );
    if (!branch) {
      setConfirmError('Sede no encontrada. Intenta de nuevo.');
      return;
    }
    const toStore = {
      id: branch.id ?? branch.branch_id,
      name: branch.name ?? branch.branch_name ?? 'Sucursal',
      address: branch.address ?? branch.address_detail ?? '',
      ...branch,
    };
    try {
      localStorage.setItem(SELECTED_BRANCH_STORAGE_KEY, JSON.stringify(toStore));
      onBranchSelected(toStore);
      window.dispatchEvent(new CustomEvent('branchUpdated'));
      // Recargar la página para aplicar el filtro de sucursal
      window.location.reload();
    } catch (e) {
      setConfirmError('No se pudo guardar la sede.');
    }
  };

  return (
    <div className="branch-modal-overlay" role="dialog" aria-modal="true" aria-labelledby="branch-modal-title">
      <div className="branch-modal">
        <div className="branch-modal-icon-wrap">
          <img src={locationImage} alt="" className="branch-modal-icon" />
        </div>
        <h2 id="branch-modal-title" className="branch-modal-title">
          Selecciona la sede más cercana a tu domicilio
        </h2>
        <p className="branch-modal-subtitle">
          Entregas más rápidas y promociones especiales.
        </p>

        {loading ? (
          <p className="branch-modal-loading">Cargando sucursales...</p>
        ) : error ? (
          <p className="branch-modal-error">{error}</p>
        ) : (
          <>
            <div className="branch-modal-select-wrap">
              <select
                className="branch-modal-select"
                value={selectedBranch}
                onChange={(e) => {
                  setSelectedBranch(e.target.value);
                  setConfirmError('');
                }}
                aria-label="Selecciona una sede"
              >
                <option value="">Selecciona una sede</option>
                {branches.map((b) => {
                  const id = b.id ?? b.branch_id;
                  return (
                    <option key={id} value={id}>
                      {b.name ?? b.branch_name ?? `Sucursal ${id}`}
                    </option>
                  );
                })}
              </select>
            </div>
            <button type="button" className="branch-modal-btn" onClick={handleConfirm}>
              Escoger Sede
            </button>
            {confirmError && <p className="branch-modal-confirm-error">{confirmError}</p>}
          </>
        )}
      </div>
    </div>
  );
};

export default BranchSelectModal;
